module.exports = "<div class=\"col-xs-12\">\r\n    <iframe src=\"../../../assets/DistantOceanKit.pdf\" style=\"width: 100%; height: 700px;\">\r\n        <p>Your browser doesn't support iframes!</p>\r\n    </iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/details/inventory/client-detail-inventory.component.html
// module id = 1074
// module chunks = 1